import { CommandListQuarantine } from "./commands/cmdListQuarantine";
import { CommandDownloadQuarantine } from "./commands/cmdDownloadQuarantine";

export class QuarantineService {
  async listFiles() {
    return new CommandListQuarantine().run();
  }

  async downloadFile(key: string) {
    return new CommandDownloadQuarantine().run(key);
  }
}
